import { render, staticRenderFns } from "./RiskAssessmentSummary.vue?vue&type=template&id=28d38a71&scoped=true&"
import script from "./RiskAssessmentSummary.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentSummary.vue?vue&type=script&lang=js&"
import style0 from "./RiskAssessmentSummary.vue?vue&type=style&index=0&id=28d38a71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d38a71",
  null
  
)

export default component.exports